module.exports = __webpack_public_path__ + "img/p1.7ec94a7f.png";